import Typography from '@mui/material/Typography';

export default function Copyright() {
    return (
      <Typography align="left">
        {' © Copyright  '}
      {new Date().getFullYear()}
      {' American Academy of Pediatrics. All rights reserved.'}
      </Typography>
    );
  }